module.exports = {
  FIELD_NUM: "Numéro département",
  FIELD_NAME: "Dénomination département",
  FIELD_BILLING_LOW: "Tarif consommations prof. puissance <= 36kVA (en MWh)",
  FIELD_BILLING_MEDIUM:
    "Tarif consommations prof. puissance > 36kVA et <= 250kVA(en MWh)",
};
